import styled, { css } from "styled-components";

const PaginationWrapperStyled = styled.nav`
    display: flex;
    align-items: center;
    margin-left: auto;
    margin-right: 0;    
    margin: 0;
    overflow: hidden;

	&:not(.flex--justify-start) {
		justify-content: center;
	}
`

const PaginationStyled = styled.ul`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0; 
    margin: 0;

	li {
		margin: 0;
		display: flex;
		
		&:before {
			content: none;
		}
	}
`

const PaginationArrowStyled = styled.button`
    width: 1.8rem;
    height: 1.8rem;
    border-radius: 0.2rem;
    background-color: #CCCCCC;
    background-position: center;
    background-size: .5rem;
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='16'%3E%3Cpath d='M6.64 8.003L.272 2.018A.84.84 0 0 1 0 1.399C0 1.164.096.945.272.78L.83.256C1.005.09 1.24 0 1.488 0s.483.09.658.256l7.582 7.127a.84.84 0 0 1 .272.621.84.84 0 0 1-.272.622l-7.575 7.12c-.175.165-.41.256-.658.256s-.483-.09-.658-.256L.28 15.22a.84.84 0 0 1 0-1.238l6.36-5.98z' fill='%23fff' fill-rule='evenodd'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    cursor: pointer;

    ${props =>
        props.previous &&
        css`
        transform: rotateY(-180deg);
        margin-right: 1rem;
        `
    }
    ${props =>
        props.active &&
        css`
        background-color: #00A76A;
        `
    }
    ${props =>
        props.next &&
        css`
        margin-left: 1rem;
        `
    }
`

const PaginationNumberStyled = styled.button`
    padding-right: 1rem;
    padding-left: 1rem;
    font-weight: 900;
    text-decoration: none;
    position: relative;
    cursor: pointer;
	font-size: 1.4rem;
    ${props =>
        props.current &&
        css`
        color: #1B1E1C;
        &:after {
            content: "";
            background: #CCCCCC;
            width: 1.5rem;
            height: .3rem;
            position: absolute;
            bottom: 0;
            left: 0;
            left: 50%;
            transform: translateX(-50%);
        }
        `
    }

	@media only screen and (min-width: ${props => props.theme.desktopSmall}) { 
		font-size: 1.6rem;
	}
`

export { PaginationWrapperStyled, PaginationStyled, PaginationArrowStyled, PaginationNumberStyled }